export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/employees";
export const ADD_DEPT_URL = "/api/v1/employees/create";
export const UPD_DEPT_URL = "/api/v1/employees/update";
